import { gql } from '@apollo/client';
import { PROPERTY_VIEWINGS_FRAGMENT } from '../fragments/propertyViewings';

export const GET_PROPERTY_VIEWINGS_QUERY = gql`
  ${PROPERTY_VIEWINGS_FRAGMENT}
  query GetPropertyViewings($input: PropertyInput) {
    getProperty(input: $input) {
      id
      ...PropertyViewings
    }
  }
`;
